import { DELETE_INGREDIENT_IN_GROCERY_LIST } from "./actionTypes";

export default (itemIds: Array) => ({
  type: DELETE_INGREDIENT_IN_GROCERY_LIST,
  payload: {
    itemIds
  },
});